export const searchTypes = {
    houseSitBooking: "house-sit-booking",
    houseSitter: "house-sitter"
}